import React from 'react';
import { Button, Typography } from '@material-ui/core';

import { useStyles } from './styles';
import { DeleteModalProps } from './types';
import { useSupplierContext } from 'contexts/complementaryRegistration';
import { Modal } from '../../../../../components/migrated/modal';

export const ModalDeleteBankDetails = (props: DeleteModalProps) => {
  const { row, open, handleClose, personIdLogged } = props;
  const classes = useStyles();
  const { setSupplierData, setHasChanges } = useSupplierContext();

  const onDelete = () => {
    setSupplierData((prevSupplierData) => {
      const bankDetailsToDeleteIndex = prevSupplierData.banksDetails.findIndex(
        (bankDetailsItem) =>
          (bankDetailsItem.item.idFDBa !== null && row.idFDBa !== null && bankDetailsItem.item.idFDBa === row.idFDBa) ||
          (bankDetailsItem.item.checkingAccount !== null &&
            row.checkingAccount !== null &&
            bankDetailsItem.item.checkingAccount === row.checkingAccount)
      );

      const updatedBankDetailsArray = [...prevSupplierData.banksDetails];

      if (bankDetailsToDeleteIndex !== -1) {
        updatedBankDetailsArray[bankDetailsToDeleteIndex] = {
          operation: 'E',
          item: updatedBankDetailsArray[bankDetailsToDeleteIndex].item
        };

        setHasChanges(true);
      }

      return {
        ...prevSupplierData,
        personIdOperation: +personIdLogged,
        banksDetails: updatedBankDetailsArray
      };
    });

    handleClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      hideClose
      disableBackdropClick
      disableEscapeKeyDown
      title="EXCLUIR REGISTRO DE DADOS BANCÁRIOS"
    >
      <div className={classes.root}>
        <div style={{ marginTop: '24px' }}>
          <Typography>Tem certeza que deseja excluir o registro?</Typography>
        </div>
        <div className={classes.buttons}>
          <Button variant="text" color="primary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button className={classes.deleteButton} variant="contained" color="primary" onClick={onDelete}>
            Excluir
          </Button>
        </div>
      </div>
    </Modal>
  );
};
